import Avatar from './UserAvatar';
import Details from './UserDetails';
import FullName from './UserFullName';

export { Details, Avatar, FullName };
